import { render, staticRenderFns } from "./external.vue?vue&type=template&id=4167c91c&scoped=true&"
import script from "./external.vue?vue&type=script&lang=js&"
export * from "./external.vue?vue&type=script&lang=js&"
import style0 from "./external.vue?vue&type=style&index=0&id=4167c91c&prod&lang=scss&scoped=true&"
import style1 from "./external.vue?vue&type=style&index=1&id=4167c91c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4167c91c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/home/vsts/work/1/s/components/PageHeader.vue').default,FormElement: require('/home/vsts/work/1/s/components/FormElement.vue').default})
